import "./GeoQuizApp.css";
import { useGeoQuizController } from "./useGeoQuizController";
import { MapSelection } from "./MenuScreen";

const MAP_TITLES: Record<MapSelection, string> = {
  poland: "Mapa Polski",
  europe: "Mapa Europy",
  world: "Mapa świata",
  "north-america": "Mapa Ameryki Północnej",
  "south-america": "Mapa Ameryki Południowej",
  africa: "Mapa Afryki",
  oceania: "Mapa Oceanii",
  asia: "Mapa Azji",
};

const MAP_PROMPTS: Record<MapSelection, string> = {
  poland: "Kliknij województwo:",
  europe: "Kliknij państwo:",
  world: "Kliknij państwo:",
  "north-america": "Kliknij państwo:",
  "south-america": "Kliknij państwo:",
  africa: "Kliknij państwo:",
  oceania: "Kliknij państwo:",
  asia: "Kliknij państwo:",
};

interface GeoQuizAppProps {
  mapSelection: MapSelection;
  onBack: () => void;
}

export function GeoQuizApp({ mapSelection, onBack }: GeoQuizAppProps) {
  const { canvasRef, uiState } = useGeoQuizController(mapSelection);
  const resultLabel =
    uiState.lastResult === "correct"
      ? "Dobrze!"
      : uiState.lastResult === "incorrect"
        ? "Niepoprawnie"
        : "";
  const resultClass =
    uiState.lastResult === "correct"
      ? "is-correct"
      : uiState.lastResult === "incorrect"
        ? "is-incorrect"
        : "";
  const overlayClass = uiState.mobileIntroVisible
    ? "GeoQuizOverlay is-mobile-intro"
    : "GeoQuizOverlay";
  const targetLabel = uiState.loading ? "Ładowanie..." : uiState.targetName;
  const hideOverlayOnMobile = uiState.isMobile && mapSelection !== "poland";

  return (
    <div className="GeoQuizApp">
      <div className="GeoQuizCanvasWrap">
        <canvas ref={canvasRef} className="GeoQuizCanvas" />
        {!hideOverlayOnMobile && (
          <div className={overlayClass}>
            <div className="GeoQuizHeader">
              <div className="GeoQuizTitle">{MAP_TITLES[mapSelection]}</div>
              <button className="GeoQuizBack" type="button" onClick={onBack}>
                Menu
              </button>
            </div>
            <div className="GeoQuizTarget">
              {MAP_PROMPTS[mapSelection]}{" "}
              <span className="GeoQuizTargetName">{targetLabel}</span>
            </div>
            <div className="GeoQuizScore">
              Wynik: {uiState.scoreCorrect}/{uiState.scoreTotal}
            </div>
            <div
              className={`GeoQuizResult ${resultClass} ${
                uiState.lastResult ? "is-visible" : ""
              }`}
            >
              {resultLabel}
            </div>
          </div>
        )}
        {hideOverlayOnMobile && (
          <button className="GeoQuizBackMobile" type="button" onClick={onBack}>
            Menu
          </button>
        )}
        {uiState.mobileIntroVisible && (
          <div className="GeoQuizMobileTarget" aria-hidden="true">
            <div className="GeoQuizMobileTargetInner">
              <div className="GeoQuizMobileTargetPrompt">
                {MAP_PROMPTS[mapSelection]}
              </div>
              <div className="GeoQuizMobileTargetName">{targetLabel}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
